import React from 'react';
import styles from "./myprofile.module.css"
import ProfileMenu from '../../Components/profilemenu/ProfileMenu';
import ProfileBody from '../../Components/profilebody/ProfileBody';

const Myprofile = ({children}) => {
    return (
        <>
            <div className={styles.myprofile}>
                <div className={styles.promenu}>
                    <ProfileMenu />
                </div>
                
                    {children}
            </div>


        </>
    );
};

export default Myprofile;
